const listaDeUsuarios = (state) => {
    return state.items || [];
}

const loadingUsuario = (state) => {
    return state.buscando
}

const listaPerfis = (state) => {
    return state.perfis
}

const perfilSelecionadoComRotas = (state) => {
    return state.selecionado
}

export {
    listaDeUsuarios,
    loadingUsuario,
    listaPerfis,
    perfilSelecionadoComRotas
}